import { useEffect } from 'react'
import { Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@cutilei/ui'
import CheckBox from 'components/CheckBox'
import { Formik } from 'formik'

import {
  Container,
  Row,
  Column,
  Label,
  SubTitle,
  InfoText,
  Button,
  ProfessionalsGrid,
  ProfessionalBlock,
  ProfessionalPicture,
  ButtonText
} from './styles'

export default function SyncServicesModal ({
  visible,
  service = {},
  professionals = [],
  onConfirm: handleConfirm,
  onClose: handleClose
}) {
  const filteredProfessionals = professionals.filter (professional => (
    service.cutilei_service ? professional.accepts_cutilei : true
  ))

  return (
    <Dialog open={visible} onOpenChange={open => { if (!open) handleClose() }}>
      <DialogContent size='md' closeOnOutsideClick={false} aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Sincronizar serviços</DialogTitle>
        </DialogHeader>
        <Formik
          initialValues={{
            'professionals': filteredProfessionals.map (professional => ({
              ...professional,
              'selected': false
            })),
            'select_all': false
          }}
          onSubmit={values => {
            const professionals = values.professionals
              .filter (professional => professional.selected)
              .map (professional => professional.id)

            handleConfirm (professionals)
            handleClose ()
          }}
        >
          {function SyncServicesForm ({
            values,
            setFieldValue,
            handleSubmit
          }) {
            useEffect (() => {
              setFieldValue ('professionals', values.professionals.map (professional => ({
                ...professional, selected: values.select_all
              })))
            }, [values.select_all])

            return (
              <>
                <DialogBody>
                  <Container>
                    <InfoText>
                      Selecione os profissionais para os quais deseja transferir as alterações feitas nos serviços.
                    </InfoText>
                    <Column>
                      <Row>
                        <CheckBox
                          id='select_all'
                          style={{marginTop: 2, marginRight: 6}}
                          value={values.select_all}
                          onValueChange={value => setFieldValue ('select_all', value)}
                        />
                        <Label htmlFor='select_all'>
                          {values.select_all ? 'Desmarcar' : 'Selecionar'} todos
                        </Label>
                      </Row>
                      <ProfessionalsGrid>
                        {values.professionals.map ((professional, index) => (
                          <ProfessionalBlock
                            key={index}
                            onClick={() => {
                              setFieldValue (`professionals.${index}.selected`, !values.professionals[index].selected)
                            }}
                            style={{margin: 0}}
                          >
                            <Column>
                              <Row style={{position: 'relative', marginBottom: 3}}>
                                <CheckBox
                                  id={`professionals.${index}.selected`}
                                  style={{position: 'absolute', top: 7, left: 7}}
                                  value={values.professionals[index].selected}
                                  onValueChange={value => {
                                    setFieldValue (`professionals.${index}.selected`, value)
                                  }}
                                />
                                <ProfessionalPicture
                                  src={professional.profile_picture}
                                  selected={values.professionals[index].selected}
                                />
                              </Row>
                              <SubTitle>
                                {professional.nickname}
                              </SubTitle>
                            </Column>
                          </ProfessionalBlock>
                        ))}
                      </ProfessionalsGrid>
                    </Column>
                  </Container>
                </DialogBody>
                <DialogFooter>
                  <Row>
                    <Button type='submit' onClick={handleSubmit}>
                      <ButtonText>
                        Confirmar
                      </ButtonText>
                    </Button>
                  </Row>
                </DialogFooter>
              </>
            )
          }}
        </Formik>
      </DialogContent>
    </Dialog>
  )
}
